import axios from "axios";
import { backend_routes, baseUrl } from "../common/links";

const axiosObject = axios.create({
    baseURL: baseUrl,
})

axiosObject.interceptors.request.use((config) => {
    config.headers.Authorization = 'Bearer '+localStorage.getItem("accessToken");
    return config;
})
axiosObject.interceptors.response.use(
    async (response) => {
        if (!response.data.status){
            const originalRequest = response.config;
            if (response.status < 300 ){
                if (response.data.errorData.code === 1007) {
                    try {
                        const tokens = await axiosObject.post(
                            backend_routes.REFRESH_TOKENS_LINK,
                            {
                                tokens: {
                                    access_token: localStorage.getItem("accessToken"),
                                    refresh_token: localStorage.getItem("refreshToken")
                                },
                                device: {
                                    model: "",
                                    app_version: "",
                                    system: "web",
                                    firebase_token: ""
                                }
                            }
                        );
                        if (tokens.data.status) {
                            localStorage.setItem("accessToken", tokens.data.data.access_token);
                            localStorage.setItem("refreshToken", tokens.data.data.refresh_token);
                            return axiosObject.request(originalRequest);
                        }
                        else return tokens;
                    } catch (error) {
                    }
                }
                else return response
            } 
            else return response;
        }
        else {
            return response
        };
    },
    (error)=>{
        return error.response;
    }
)

export default axiosObject;